import "jquery";

export class TypeNewPassword {
    private $newPasswordLoader: JQuery;
    private $newPasswordBtn: JQuery;
    private $passwordRecovery: JQuery; 

    constructor() {
        this.$newPasswordBtn = $("#newPasswordBtn");
        this.$newPasswordLoader = $("#newPasswordLoader");
        this.$passwordRecovery = $("#passwordRecovery");
        
    }


    init(): void {
        const self = this;

        $('[data-action="submitNewPassword"]').on("submit",
            function(e: any) {
                //e.preventDefault();
                if (self.$passwordRecovery.valid()) {
                    self.$newPasswordLoader.addClass("loading");
                    self.$newPasswordBtn.prop("disabled", true);
                }
                
            });
    }
}